"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8932],{

/***/ 8932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KontentContextConsumer": function() { return /* binding */ KontentContextConsumer; },
  "make": function() { return /* binding */ RegisterComponent_bs_make; }
});

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/components/library/SmartLink.bs.js
var SmartLink_bs = __webpack_require__(35705);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpSteps.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
function getNextStep(step) {
    switch(step){
        case /* CaptureNames */ 0:
            return /* CaptureEmail */ 1;
        case /* CaptureEmail */ 1:
            return /* CapturePassword */ 2;
        case /* CapturePassword */ 2:
            return /* CapturePhoneNumber */ 3;
        case /* CapturePhoneNumber */ 3:
        case /* ConfirmSecurityCode */ 4:
            return /* ConfirmSecurityCode */ 4;
    }
}
function getPrevStep(step) {
    switch(step){
        case /* CaptureNames */ 0:
        case /* CaptureEmail */ 1:
            return /* CaptureNames */ 0;
        case /* CapturePassword */ 2:
            return /* CaptureEmail */ 1;
        case /* CapturePhoneNumber */ 3:
            return /* CapturePassword */ 2;
        case /* ConfirmSecurityCode */ 4:
            return /* CapturePhoneNumber */ 3;
    }
}
function getStepIndex(step) {
    return step + 1 | 0;
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/Regex.bs.js
var Regex_bs = __webpack_require__(7618);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/library/NextButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function NextButton(props) {
    var isDisabled = props.isDisabled;
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var nextButtonText = belt_Option/* mapWithDefault */.k7(registerData, "Continue", function(c) {
        return c.nextButtonText;
    });
    return jsx_runtime.jsxs("button", {
        children: [
            jsx_runtime.jsx("span", {
                children: util_bs/* ReactStuff.s */.p_.s(nextButtonText),
                className: "inline-block align-middle"
            }),
            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                icon: [
                    "fas",
                    "arrow-circle-right"
                ],
                className: isDisabled ? "inline-block align-middle ml-2 text-4xl text-smoke-light" : "inline-block align-middle ml-2 text-4xl text-prezzee-red"
            })
        ],
        className: belt_Option/* getWithDefault */.tj(props.className, ""),
        id: props.id,
        disabled: isDisabled,
        type: props.type_,
        onClick: props.onClick
    });
}
var make = NextButton;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/bindings/ReactHookForm.bs.js
var ReactHookForm_bs = __webpack_require__(77103);
// EXTERNAL MODULE: ./src/components/pages/register/steps/SignUpStepStyles.bs.js
var SignUpStepStyles_bs = __webpack_require__(96626);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js
var RichText_bs = __webpack_require__(78078);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js + 1 modules
var TextField_bs = __webpack_require__(98923);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpForName.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













var SignUpForName_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var onNextBtnClick = props.onNextBtnClick;
    var dispatch = props.dispatch;
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var stepTitleName = belt_Option/* mapWithDefault */.k7(registerData, "<p>Hello,</p><p>What's your name?</p>", function(c) {
        return c.stepTitleName;
    });
    var firstNameLabel = belt_Option/* mapWithDefault */.k7(registerData, "First name", function(c) {
        return c.firstNameLabel;
    });
    var firstNameRequiredText = belt_Option/* mapWithDefault */.k7(registerData, "First name is required", function(c) {
        return c.firstNameRequiredText;
    });
    var invalidFirstNameText = belt_Option/* mapWithDefault */.k7(registerData, "Please enter a valid name", function(c) {
        return c.invalidFirstNameText;
    });
    var lastNameLabel = belt_Option/* mapWithDefault */.k7(registerData, "Last name", function(c) {
        return c.lastNameLabel;
    });
    var lastNameRequiredText = belt_Option/* mapWithDefault */.k7(registerData, "Last name is required", function(c) {
        return c.lastNameRequiredText;
    });
    var invalidLastNameText = belt_Option/* mapWithDefault */.k7(registerData, "Please enter a valid name", function(c) {
        return c.invalidLastNameText;
    });
    var firstNameInput = {
        required: {
            value: true,
            message: firstNameRequiredText
        },
        pattern: {
            value: Regex_bs/* notOnlySpaceRegex */.qc,
            message: invalidFirstNameText
        }
    };
    var lastNameInput = {
        required: {
            value: true,
            message: lastNameRequiredText
        },
        pattern: {
            value: Regex_bs/* notOnlySpaceRegex */.qc,
            message: invalidLastNameText
        }
    };
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "all",
        defaultValues: {
            firstName: props.stateFirstName,
            lastName: props.stateLastName
        }
    }, undefined);
    var onSubmit = react.useCallback(function(param) {
        var lastName = param.lastName;
        var firstName = param.firstName;
        if (!(firstName == null) && !(lastName == null)) {
            curry._1(dispatch, {
                TAG: /* Step1Update */ 0,
                firstName: firstName,
                lastName: lastName
            });
            return curry._1(onNextBtnClick, undefined);
        }
    }, [
        dispatch
    ]);
    return jsx_runtime.jsxs("form", {
        children: [
            jsx_runtime.jsx("label", {
                children: jsx_runtime.jsx(RichText_bs.make, {
                    children: stepTitleName
                }),
                className: SignUpStepStyles_bs/* formLabel */.Xv,
                htmlFor: "FirstName"
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                    autoComplete: "given-name",
                    autoFocus: true,
                    className: SignUpStepStyles_bs/* formInput_ */.Gr,
                    label: firstNameLabel,
                    name: "firstName",
                    type_: "text",
                    error: belt_Option/* isSome */.pC(FormHelpers_bs/* getFieldError */.zQ(form.errors, "firstName")),
                    helperText: belt_Option/* getWithDefault */.tj(FormHelpers_bs/* getFieldError */.zQ(form.errors, "firstName"), ""),
                    inputRef: caml_option/* some */.G(curry._1(form.register, firstNameInput))
                }),
                className: "mb-6"
            }),
            jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                autoComplete: "family-name",
                className: SignUpStepStyles_bs/* formInput_ */.Gr,
                label: lastNameLabel,
                name: "lastName",
                type_: "text",
                error: belt_Option/* isSome */.pC(FormHelpers_bs/* getFieldError */.zQ(form.errors, "lastName")),
                helperText: belt_Option/* getWithDefault */.tj(FormHelpers_bs/* getFieldError */.zQ(form.errors, "lastName"), ""),
                inputRef: caml_option/* some */.G(curry._1(form.register, lastNameInput))
            }),
            jsx_runtime.jsx(make, {
                className: form.formState.isValid ? SignUpStepStyles_bs/* nextButton */.F2 : SignUpStepStyles_bs/* nextButtonDisabled */.gB,
                isDisabled: !form.formState.isValid,
                type_: "submit"
            })
        ],
        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
    });
});
 /* make Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/PreviousButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function PreviousButton(props) {
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var backButtonText = belt_Option/* mapWithDefault */.k7(registerData, "Back", function(c) {
        return c.backButtonText;
    });
    return jsx_runtime.jsxs("button", {
        children: [
            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                icon: [
                    "fas",
                    "arrow-left"
                ],
                className: "mr-5 text-2xl text-gray-400 inline-block align-middle"
            }),
            jsx_runtime.jsx("span", {
                children: util_bs/* ReactStuff.s */.p_.s(backButtonText),
                className: "inline-block align-middle text-gray-400"
            })
        ],
        className: belt_Option/* getWithDefault */.tj(props.className, ""),
        id: props.id,
        type: belt_Option/* getWithDefault */.tj(props.type_, "button"),
        onClick: props.onClick
    });
}
var PreviousButton_bs_make = PreviousButton;
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpForEmail.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE














var SignUpForEmail_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var dispatch = props.dispatch;
    var onNextBtnClick = props.onNextBtnClick;
    var onPreviousBtnClick = props.onPreviousBtnClick;
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var userName = FormHelpers_bs/* getValue */.NA(props.stateFirstName);
    var stepTitleEmail = belt_Option/* mapWithDefault */.k7(registerData, "<p>Hi " + (userName + ",</p><p>Please enter your email</p>"), function(c) {
        return c.stepTitleEmail.replace("{0}", userName);
    });
    var emailLabel = belt_Option/* mapWithDefault */.k7(registerData, "Email", function(c) {
        return c.emailLabel;
    });
    var emailRequiredText = belt_Option/* mapWithDefault */.k7(registerData, "Your email is required", function(c) {
        return c.emailRequiredText;
    });
    var invalidEmailText = belt_Option/* mapWithDefault */.k7(registerData, "Please enter a valid email address", function(c) {
        return c.invalidEmailText;
    });
    var emailInput = {
        required: {
            value: true,
            message: emailRequiredText
        },
        pattern: {
            value: Regex_bs/* emailRegex */.HN,
            message: invalidEmailText
        }
    };
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "all",
        defaultValues: {
            email: props.stateEmail
        }
    }, undefined);
    var onSubmit = react.useCallback(function(data) {
        var email = FormHelpers_bs/* getValue */.NA(data.email);
        if (email !== "") {
            curry._1(dispatch, {
                TAG: /* Step2Update */ 1,
                email: email
            });
        }
        curry._1(onNextBtnClick, undefined);
    }, [
        dispatch
    ]);
    return jsx_runtime.jsxs("form", {
        children: [
            jsx_runtime.jsx("label", {
                children: jsx_runtime.jsx(RichText_bs.make, {
                    children: stepTitleEmail
                }),
                className: SignUpStepStyles_bs/* formLabel */.Xv
            }),
            jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                autoComplete: "off",
                autoFocus: true,
                className: SignUpStepStyles_bs/* formInput_ */.Gr,
                label: emailLabel,
                name: "email",
                type_: "email",
                error: belt_Option/* isSome */.pC(FormHelpers_bs/* getError */.by(form.formState.touched, "email", form.errors)),
                helperText: belt_Option/* getWithDefault */.tj(FormHelpers_bs/* getError */.by(form.formState.touched, "email", form.errors), ""),
                inputRef: caml_option/* some */.G(curry._1(form.register, emailInput))
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(PreviousButton_bs_make, {
                        onClick: function onClick(param) {
                            curry._1(dispatch, {
                                TAG: /* Step2Update */ 1,
                                email: FormHelpers_bs/* getValue */.NA(curry._1(form.getValues, undefined).email)
                            });
                            curry._1(onPreviousBtnClick, undefined);
                        },
                        className: SignUpStepStyles_bs/* previousButton */.TF
                    }),
                    jsx_runtime.jsx(make, {
                        className: form.formState.isValid ? SignUpStepStyles_bs/* nextButton */.F2 : SignUpStepStyles_bs/* nextButtonDisabled */.gB,
                        isDisabled: !form.formState.isValid,
                        type_: "submit"
                    })
                ],
                className: "flex items-center justify-between"
            })
        ],
        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
    });
});
 /* make Not a pure module */ 

;// CONCATENATED MODULE: ./src/utils/OnboardingReducer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var initialState_firstName = null;
var initialState_lastName = null;
var initialState_email = null;
var initialState_password = null;
var initialState_phoneNumber = null;
var initialState = {
    firstName: initialState_firstName,
    lastName: initialState_lastName,
    email: initialState_email,
    password: initialState_password,
    phoneNumber: initialState_phoneNumber,
    marketingOptIn: false
};
function reducer(state, action) {
    switch(action.TAG | 0){
        case /* Step1Update */ 0:
            return {
                firstName: action.firstName,
                lastName: action.lastName,
                email: state.email,
                password: state.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
            };
        case /* Step2Update */ 1:
            return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: action.email,
                password: state.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
            };
        case /* Step3Update */ 2:
            return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: state.email,
                password: action.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
            };
        case /* Step4Update */ 3:
            return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: state.email,
                password: state.password,
                phoneNumber: action.phoneNumber,
                marketingOptIn: action.marketingOptIn
            };
    }
}
function useOnboardingReducer(param) {
    return react.useReducer(reducer, initialState);
}
 /* react Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/ProgressIndicator.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var progressIndicatorStyle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flexGrow */.H78(1),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(4)),
        tl: {
            hd: BsCss_bs/* borderBottomWidth */.HMX(BsCss_bs.px(4)),
            tl: {
                hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(10)),
                tl: /* [] */ 0
            }
        }
    }
});
var currentStepsStyle = Cn_bs/* make */.S([
    progressIndicatorStyle,
    curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* borderColor */.tvt(Theme_bs/* Color.red400 */.Il.red400),
        tl: /* [] */ 0
    })
]);
var remainingStepsStyle = Cn_bs/* make */.S([
    progressIndicatorStyle,
    curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* borderColor */.tvt(Theme_bs/* Color.gray100 */.Il.gray100),
        tl: /* [] */ 0
    })
]);
function makeStepMarkup(stepIndex, stepsIter) {
    if (stepsIter <= stepIndex) {
        return jsx_runtime.jsx("div", {
            className: currentStepsStyle
        }, "step" + String(stepsIter));
    } else {
        return jsx_runtime.jsx("div", {
            className: remainingStepsStyle
        }, "step" + String(stepsIter));
    }
}
function ProgressIndicator(props) {
    var partial_arg = getStepIndex(props.step);
    return jsx_runtime.jsx("div", {
        children: belt_Array/* map */.UI(belt_Array/* range */.w6(1, 5), function(param) {
            return makeStepMarkup(partial_arg, param);
        }),
        className: "flex mb-4"
    });
}
var ProgressIndicator_bs_make = ProgressIndicator;
 /* progressIndicatorStyle Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./src/api/PrezzeePublicClient.bs.js + 15 modules
var PrezzeePublicClient_bs = __webpack_require__(47861);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpForPassword.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


















var SignUpForPassword_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var state = props.state;
    var dispatch = props.dispatch;
    var onNextBtnClick = props.onNextBtnClick;
    var onPreviousBtnClick = props.onPreviousBtnClick;
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var stepTitlePassword = belt_Option/* mapWithDefault */.k7(registerData, "<p>Awesome!</p><p>Choose a secure password which:</p>", function(c) {
        return c.stepTitlePassword;
    });
    var passwordRequirements = belt_Option/* mapWithDefault */.k7(registerData, "\n      <ul>\n        <li>\n          Has a minimum 8 characters\n        </li>\n        <li >\n          Has at least one lower case letter\n        </li>\n        <li>\n          Has at least one upper case letter\n        </li>\n        <li>\n          Has at least one digit\n        </li>\n      </ul>", function(c) {
        return c.passwordRequirements;
    });
    var passwordLabel = belt_Option/* mapWithDefault */.k7(registerData, "Password", function(c) {
        return c.passwordLabel;
    });
    var passwordRequiredText = belt_Option/* mapWithDefault */.k7(registerData, "Password is required", function(c) {
        return c.passwordRequiredText;
    });
    var invalidPasswordText = belt_Option/* mapWithDefault */.k7(registerData, "Please retry with a more secure password. (Max: 100 Characters)", function(c) {
        return c.invalidPasswordText;
    });
    var passwordInput = {
        required: {
            value: true,
            message: passwordRequiredText
        },
        pattern: {
            value: Regex_bs/* passwordRegex */.BV,
            message: invalidPasswordText
        }
    };
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "all",
        defaultValues: {
            password: props.statePassword
        }
    }, undefined);
    var onSubmit = react.useCallback(function(data) {
        var password = FormHelpers_bs/* getValue */.NA(data.password);
        if (password !== "") {
            curry._1(dispatch, {
                TAG: /* Step3Update */ 2,
                password: password
            });
        }
        js_promise/* then_ */.k(function(data) {
            if (data.TAG === /* Ok */ 0) {
                return Promise.resolve(curry._1(onNextBtnClick, undefined));
            }
            var e = data._0;
            switch(e.TAG | 0){
                case /* NetworkError */ 0:
                case /* JsonParsingError */ 1:
                    return Promise.resolve(curry._2(form.setError, "password", {
                        type: "manual",
                        message: "Unexpected error, please try again later"
                    }));
                case /* ServerError */ 2:
                    var serverError = e._0;
                    if (typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */ 0) {
                        return Promise.resolve(curry._2(form.setError, "password", {
                            type: "manual",
                            message: "Unexpected error, please try again later"
                        }));
                    } else {
                        return Promise.resolve(curry._2(form.setError, "password", {
                            type: "manual",
                            message: belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(serverError._0.split("Password: "), 1), "This password is too common.")
                        }));
                    }
            }
        }, PrezzeePublicClient_bs.validateCustomerPassword({
            firstName: belt_Option/* getWithDefault */.tj(caml_option/* nullable_to_opt */.Tl(state.firstName), ""),
            lastName: belt_Option/* getWithDefault */.tj(caml_option/* nullable_to_opt */.Tl(state.lastName), ""),
            email: belt_Option/* getWithDefault */.tj(caml_option/* nullable_to_opt */.Tl(state.email), ""),
            password: password
        }));
    }, [
        dispatch
    ]);
    return jsx_runtime.jsxs("form", {
        children: [
            jsx_runtime.jsx("label", {
                children: jsx_runtime.jsx(RichText_bs.make, {
                    children: stepTitlePassword
                }),
                className: SignUpStepStyles_bs/* formLabel */.Xv
            }),
            jsx_runtime.jsx(RichText_bs.make, {
                children: passwordRequirements,
                className: Cn_bs/* make */.S([
                    SignUpStepStyles_bs/* list */.pb,
                    "w-full text-left pl-5 mb-8"
                ])
            }),
            jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                autoFocus: true,
                className: SignUpStepStyles_bs/* formInput_ */.Gr,
                label: passwordLabel,
                name: "password",
                type_: "password",
                error: belt_Option/* isSome */.pC(FormHelpers_bs/* getError */.by(form.formState.touched, "password", form.errors)),
                helperText: belt_Option/* getWithDefault */.tj(FormHelpers_bs/* getError */.by(form.formState.touched, "password", form.errors), ""),
                inputRef: caml_option/* some */.G(curry._1(form.register, passwordInput))
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(PreviousButton_bs_make, {
                        onClick: function onClick(param) {
                            curry._1(dispatch, {
                                TAG: /* Step3Update */ 2,
                                password: FormHelpers_bs/* getValue */.NA(curry._1(form.getValues, undefined).password)
                            });
                            curry._1(onPreviousBtnClick, undefined);
                        },
                        className: SignUpStepStyles_bs/* previousButton */.TF
                    }),
                    jsx_runtime.jsx(make, {
                        className: form.formState.isValid ? SignUpStepStyles_bs/* nextButton */.F2 : SignUpStepStyles_bs/* nextButtonDisabled */.gB,
                        isDisabled: !form.formState.isValid,
                        type_: "submit"
                    })
                ],
                className: "flex items-center justify-between"
            })
        ],
        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
    });
});
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
// EXTERNAL MODULE: ./src/components/library/SecurityCodeVerification.bs.js
var SecurityCodeVerification_bs = __webpack_require__(31292);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpSecurityCode.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var nestedInput = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* selector */.nZE("input", {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(6)),
                tl: {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(36)),
                    tl: {
                        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(42)),
                        tl: {
                            hd: BsCss_bs/* boxSizing */.ixg("borderBox"),
                            tl: {
                                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
                                tl: {
                                    hd: BsCss_bs/* margin */.e6$(BsCss_bs.px(4)),
                                    tl: {
                                        hd: BsCss_bs/* borderWidth */.J4J(BsCss_bs.px(1)),
                                        tl: {
                                            hd: BsCss_bs/* borderStyle */.$uf("solid"),
                                            tl: {
                                                hd: BsCss_bs/* borderColor */.tvt(Theme_bs/* Color.lightGrey */.Il.lightGrey),
                                                tl: {
                                                    hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(0), BsCss_bs.px(10), undefined, undefined, Css_bs/* rgba */.m4f(0, 0, 0, BsCss_bs/* pct */.hdZ(10.0)))),
                                                    tl: {
                                                        hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(5)),
                                                        tl: {
                                                            hd: BsCss_bs/* textAlign */.ydu("center"),
                                                            tl: /* [] */ 0
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    tl: /* [] */ 0
});
var Styles = {
    nestedInput: nestedInput
};
var SignUpSecurityCode_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var segmentData = props.segmentData;
    var purchaseCallback = props.purchaseCallback;
    var signupType = props.signupType;
    var state = props.state;
    var state_firstName = state.firstName;
    var state_lastName = state.lastName;
    var state_email = state.email;
    var state_password = state.password;
    var state_phoneNumber = state.phoneNumber;
    var state_marketingOptIn = state.marketingOptIn;
    var state$1 = {
        firstName: state_firstName,
        lastName: state_lastName,
        email: state_email,
        password: state_password,
        phoneNumber: state_phoneNumber,
        marketingOptIn: state_marketingOptIn
    };
    if (purchaseCallback !== undefined) {
        if (segmentData !== undefined) {
            return jsx_runtime.jsx(SecurityCodeVerification_bs/* make */.Sy, {
                state: state$1,
                signupType: signupType,
                purchaseCallback: purchaseCallback,
                segmentData: segmentData
            });
        } else {
            return jsx_runtime.jsx(SecurityCodeVerification_bs/* make */.Sy, {
                state: state$1,
                signupType: signupType,
                purchaseCallback: purchaseCallback
            });
        }
    } else if (segmentData !== undefined) {
        return jsx_runtime.jsx(SecurityCodeVerification_bs/* make */.Sy, {
            state: state$1,
            signupType: signupType,
            segmentData: segmentData
        });
    } else {
        return jsx_runtime.jsx(SecurityCodeVerification_bs/* make */.Sy, {
            state: state$1,
            signupType: signupType
        });
    }
});
 /* nestedInput Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
// EXTERNAL MODULE: ./src/components/forms/PhoneField.bs.js + 1 modules
var PhoneField_bs = __webpack_require__(37595);
// EXTERNAL MODULE: ./src/utils/FormReducer.bs.js
var FormReducer_bs = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/library/Notification.bs.js
var Notification_bs = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/components/forms/ErrorFieldText.bs.js
var ErrorFieldText_bs = __webpack_require__(93106);
// EXTERNAL MODULE: ./src/forms/FormValidators.bs.js
var FormValidators_bs = __webpack_require__(50884);
// EXTERNAL MODULE: ./src/forms/OnboardingForms.bs.js
var OnboardingForms_bs = __webpack_require__(47846);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
;// CONCATENATED MODULE: ./src/components/pages/register/steps/SignUpForPhoneNumber.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE























var invalidMsg = "Invalid phone number";
var SignUpForPhoneNumber_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var dispatch = props.dispatch;
    var stateEmail = props.stateEmail;
    var onNextBtnClick = props.onNextBtnClick;
    var match = FormReducer_bs/* useFormReducer */.BZ(undefined);
    var formDispatch = match[1];
    var formState = match[0];
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var stepTitlePhoneNumber = belt_Option/* mapWithDefault */.k7(registerData, "<p>Last step,</p><p>What's your number so we can send you a code?</p>", function(c) {
        return c.stepTitlePhoneNumber;
    });
    var phoneNumberRequiredText = belt_Option/* mapWithDefault */.k7(registerData, "Phone number is required", function(c) {
        return c.phoneNumberRequiredText;
    });
    var invalidPhoneNumberText = belt_Option/* mapWithDefault */.k7(registerData, "Please enter a valid mobile number", function(c) {
        return c.invalidPhoneNumberText;
    });
    var newsletterCheckboxLabel = belt_Option/* mapWithDefault */.k7(registerData, "Yes, I'd like to be first to receive news and special offers from PREZZEE.", function(c) {
        return c.newsletterCheckboxLabel;
    });
    var tAndCsCheckboxLabel = belt_Option/* mapWithDefault */.k7(registerData, "\n          By continuing, you agree to Prezzee's\n          <a\n            target='_blank'\n            href='/policies/privacy-policy/'>\n            Privacy Policy\n          </a>\n           and\n          <a\n            target='_blank'\n            href='/policies/terms-of-service/'>\n            Terms of Services.\n          </a>\n    ", function(c) {
        return c.tAndCsCheckboxLabel;
    });
    var nzNotPrezzyDisclaimer = belt_Option/* mapWithDefault */.k7(registerData, 'By continuing I acknowledge and understand that "Prezzee" is not affiliated or associated in any way with "PREZZY\xae", "PREZZY\xae\xa0Card" or EPAY NEW ZEALAND LIMITED (NZBN 9429036203420) and PREZZY\xae\xa0is a registered trade mark of Epay New Zealand Limited"', function(c) {
        return c.nzNotPrezzyDisclaimer;
    });
    var sendSecurityCodeCtaText = belt_Option/* mapWithDefault */.k7(registerData, "Send SMS verification code", function(c) {
        return c.sendSecurityCodeCtaText;
    });
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: {
            phoneNumber: null,
            marketingOptIn: caml_obj/* notequal */.$k(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), {
                TAG: /* Ok */ 0,
                _0: /* GreatBritain */ 1
            }),
            nzTnC: caml_obj/* notequal */.$k(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), {
                TAG: /* Ok */ 0,
                _0: /* NewZealand */ 3
            }),
            prezzeeTnC: false
        }
    }, undefined);
    var phoneControllerOptions = FormHelpers_bs/* getPhoneControllerOptions */.V8(form.control, "phoneNumber", true);
    var match$1 = index_esm/* useController */.bc(phoneControllerOptions);
    var match$2 = match$1.field;
    var phoneValue = match$2.value;
    var phoneError = belt_Option/* map */.UI(js_dict/* get */.U2(form.errors, "phoneNumber"), function(param) {
        if (FormHelpers_bs/* getPhoneNumber */.ly(phoneValue) === "") {
            return phoneNumberRequiredText;
        } else {
            return invalidPhoneNumberText;
        }
    });
    var onSubmit = react.useCallback(function(data) {
        curry._1(formDispatch, /* Submit */ 0);
        var phoneNumber = FormHelpers_bs/* getPhoneNumber */.ly(data.phoneNumber);
        var email = FormHelpers_bs/* getValue */.NA(stateEmail);
        if (!(phoneNumber !== "" && email !== "")) {
            return curry._1(formDispatch, /* Error */ {
                _0: invalidMsg
            });
        }
        var phoneNumberStr = "+" + FormValidators_bs/* getCleanPhoneNumber */.q3(phoneNumber);
        js_promise/* then_ */.k(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve(curry._1(formDispatch, /* Error */ {
                    _0: invalidMsg
                }));
            }
            curry._1(dispatch, {
                TAG: /* Step4Update */ 3,
                phoneNumber: phoneNumberStr,
                marketingOptIn: data.marketingOptIn
            });
            return Promise.resolve(curry._1(onNextBtnClick, undefined));
        }, PrezzeePublicClient_bs.securityCode({
            email: email,
            phoneNumber: phoneNumberStr
        }));
    }, [
        dispatch,
        stateEmail
    ]);
    var e = formState.error;
    return jsx_runtime.jsxs("form", {
        children: [
            e !== undefined ? jsx_runtime.jsx(Notification_bs.make, {
                notificationType: /* NotificationError */ 0,
                title: "An error occured",
                description: e
            }) : null,
            jsx_runtime.jsx("label", {
                children: jsx_runtime.jsx(RichText_bs.make, {
                    children: stepTitlePhoneNumber
                }),
                className: SignUpStepStyles_bs/* formLabel */.Xv
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(PhoneField_bs/* TSXComponent.make */.F.make, {
                    error: belt_Option/* getWithDefault */.tj(phoneError, ""),
                    fieldOnBlur: match$2.onBlur,
                    fieldOnChange: match$2.onChange
                }),
                className: "text-left"
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs("label", {
                    children: [
                        jsx_runtime.jsx("input", {
                            ref: caml_option/* some */.G(curry._1(form.register, OnboardingForms_bs/* marketingOptInInput */.g9)),
                            className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                            name: "marketingOptIn",
                            type: "checkbox"
                        }),
                        jsx_runtime.jsx("span", {
                            children: util_bs/* ReactStuff.s */.p_.s(newsletterCheckboxLabel),
                            className: "ml-2"
                        })
                    ],
                    className: "inline-flex items-center"
                }),
                className: "mt-6 w-full text-sm text-left"
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs("label", {
                    children: [
                        jsx_runtime.jsx("input", {
                            ref: caml_option/* some */.G(curry._1(form.register, OnboardingForms_bs/* prezzeeTnCInput */.Xk)),
                            className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                            name: "prezzeeTnC",
                            type: "checkbox"
                        }),
                        jsx_runtime.jsx("span", {
                            children: jsx_runtime.jsx(RichText_bs.make, {
                                children: tAndCsCheckboxLabel,
                                className: SignUpStepStyles_bs/* tAndCs */.d7
                            }),
                            className: "ml-2"
                        })
                    ],
                    className: "inline-flex items-center"
                }),
                className: "mt-4 w-full text-sm text-left"
            }),
            jsx_runtime.jsx(ErrorFieldText_bs/* make */.S, {
                error: FormHelpers_bs/* getFieldError */.zQ(form.errors, "prezzeeTnC")
            }),
            caml_obj/* equal */.Dg(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), {
                TAG: /* Ok */ 0,
                _0: /* NewZealand */ 3
            }) ? jsx_runtime.jsxs(jsx_runtime.Fragment, {
                children: [
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsxs("label", {
                            children: [
                                jsx_runtime.jsx("input", {
                                    ref: caml_option/* some */.G(curry._1(form.register, OnboardingForms_bs/* nzTnCInput */.mj)),
                                    className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                                    name: "nzTnC",
                                    type: "checkbox"
                                }),
                                jsx_runtime.jsx("span", {
                                    children: jsx_runtime.jsx(RichText_bs.make, {
                                        children: nzNotPrezzyDisclaimer
                                    }),
                                    className: "ml-2 text-link-blue"
                                })
                            ],
                            className: "inline-flex items-center"
                        }),
                        className: "mt-4 w-full text-xs text-left"
                    }),
                    jsx_runtime.jsx(ErrorFieldText_bs/* make */.S, {
                        error: FormHelpers_bs/* getFieldError */.zQ(form.errors, "nzTnC")
                    })
                ]
            }) : null,
            jsx_runtime.jsx(Button_bs.make, {
                children: jsx_runtime.jsx("button", {
                    children: util_bs/* ReactStuff.s */.p_.s(sendSecurityCodeCtaText),
                    className: SignUpStepStyles_bs/* submitBtn */.rD,
                    disabled: formState.isSubmitting,
                    type: "submit"
                })
            })
        ],
        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
    });
});
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./src/utils/ProductPageSegmentHook.bs.js
var ProductPageSegmentHook_bs = __webpack_require__(50857);
// EXTERNAL MODULE: ./src/components/pages/register/SignUpOnboardingStyles.bs.js
var SignUpOnboardingStyles_bs = __webpack_require__(73131);
;// CONCATENATED MODULE: ./src/components/pages/register/RegisterComponent.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






















function RegisterComponent(props) {
    var purchaseCallback = props.purchaseCallback;
    var layoutData = LayoutDataContext_bs/* useContext */.qp(undefined);
    var registerData = belt_Option/* flatMap */.VS(layoutData, function(o) {
        return o.register;
    });
    var match = useOnboardingReducer(undefined);
    var dispatch = match[1];
    var state = match[0];
    var match$1 = react.useState(function() {
        return /* CaptureNames */ 0;
    });
    var setStep = match$1[1];
    var step = match$1[0];
    var router = next_router.useRouter();
    var path = router.asPath;
    var refQueryOpt = js_dict/* get */.U2(router.query, "ref");
    var signupTypeFromRefQuery = refQueryOpt === "store" ? /* DuringPurchase */ 1 : /* SignupPage */ 4;
    var deduceRegistrationFlowSignupType = function deduceRegistrationFlowSignupType(signupType, signupTypeFromRefQuery) {
        if (signupType !== 0) {
            if (signupTypeFromRefQuery !== 1) {
                return /* SignupPage */ 4;
            } else {
                return /* DuringPurchase */ 1;
            }
        } else {
            return /* GiftOpen */ 0;
        }
    };
    var registrationFlowSignupType = deduceRegistrationFlowSignupType(props.signupType, signupTypeFromRefQuery);
    var registrationFlowSignupTypeString = Segment_bs/* Registration.getSignupTypeAsString */.YM.getSignupTypeAsString(registrationFlowSignupType);
    var segmentUuid = react.useRef(ProductPageSegmentHook_bs/* generateUniqueUserId */.QX(undefined));
    var segmentData_signup_instance_id = segmentUuid.current;
    var segmentData = {
        signup_instance_id: segmentData_signup_instance_id,
        path: path
    };
    var title_ = belt_Option/* mapWithDefault */.k7(registerData, "Sign up to Prezzee", function(c) {
        return c.title;
    });
    var subtitle_ = belt_Option/* flatMap */.VS(registerData, function(c) {
        return c.subtitle;
    });
    var match$2 = belt_Option/* mapWithDefault */.k7(registerData, SmartLink_bs/* emptySmartLink */.R, function(c) {
        return c.smartLink;
    });
    var handlePreviousBtnClick = function handlePreviousBtnClick(param) {
        curry._1(setStep, function(param) {
            return getPrevStep(step);
        });
    };
    var makeSegmentCallData = function makeSegmentCallData(element) {
        return Segment_bs/* Registration.makeBaseData */.YM.makeBaseData(element, segmentUuid.current, path, registrationFlowSignupTypeString);
    };
    var makeSegmentCall = function makeSegmentCall(param) {
        switch(step){
            case /* CaptureNames */ 0:
                return;
            case /* CaptureEmail */ 1:
                return Segment_bs/* customElementInteraction */.pA(makeSegmentCallData("sign_up_first_last_name"));
            case /* CapturePassword */ 2:
                return Segment_bs/* customElementInteraction */.pA(makeSegmentCallData("sign_up_email"));
            case /* CapturePhoneNumber */ 3:
                return Segment_bs/* customElementInteraction */.pA(makeSegmentCallData("sign_up_password"));
            case /* ConfirmSecurityCode */ 4:
                return Segment_bs/* customElementInteraction */.pA(makeSegmentCallData("sign_up_mobile_verification"));
        }
    };
    var handleNextBtnClick = function handleNextBtnClick(param) {
        curry._1(setStep, function(param) {
            return getNextStep(step);
        });
    };
    react.useEffect(function() {
        makeSegmentCall(undefined);
    }, [
        step
    ]);
    var tmp;
    switch(step){
        case /* CaptureNames */ 0:
            tmp = jsx_runtime.jsx(SignUpForName_bs_make, {
                stateFirstName: state.firstName,
                stateLastName: state.lastName,
                dispatch: dispatch,
                onNextBtnClick: handleNextBtnClick
            });
            break;
        case /* CaptureEmail */ 1:
            tmp = jsx_runtime.jsx(SignUpForEmail_bs_make, {
                onPreviousBtnClick: handlePreviousBtnClick,
                onNextBtnClick: handleNextBtnClick,
                stateEmail: state.email,
                stateFirstName: state.firstName,
                dispatch: dispatch
            });
            break;
        case /* CapturePassword */ 2:
            tmp = jsx_runtime.jsx(SignUpForPassword_bs_make, {
                onPreviousBtnClick: handlePreviousBtnClick,
                onNextBtnClick: handleNextBtnClick,
                statePassword: state.password,
                dispatch: dispatch,
                state: state
            });
            break;
        case /* CapturePhoneNumber */ 3:
            tmp = jsx_runtime.jsx(SignUpForPhoneNumber_bs_make, {
                onNextBtnClick: handleNextBtnClick,
                stateEmail: state.email,
                dispatch: dispatch
            });
            break;
        case /* ConfirmSecurityCode */ 4:
            tmp = purchaseCallback !== undefined ? jsx_runtime.jsx(SignUpSecurityCode_bs_make, {
                state: state,
                signupType: registrationFlowSignupType,
                purchaseCallback: purchaseCallback,
                segmentData: segmentData
            }) : jsx_runtime.jsx(SignUpSecurityCode_bs_make, {
                state: state,
                signupType: registrationFlowSignupType,
                segmentData: segmentData
            });
            break;
    }
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("h1", {
                        children: util_bs/* ReactStuff.s */.p_.s(title_),
                        className: SignUpOnboardingStyles_bs/* title */.TN
                    }),
                    subtitle_ !== undefined ? jsx_runtime.jsx("h2", {
                        children: util_bs/* ReactStuff.s */.p_.s(subtitle_),
                        className: SignUpOnboardingStyles_bs/* subtitle */.Oc
                    }) : null,
                    jsx_runtime.jsx(ProgressIndicator_bs_make, {
                        step: step
                    }),
                    tmp
                ],
                className: "pb-20"
            })
        }),
        itemId: match$2.itemId,
        elementCodename: match$2.codename
    });
}
var KontentContextConsumer;
var RegisterComponent_bs_make = RegisterComponent;
 /* Util Not a pure module */ 


/***/ }),

/***/ 73131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gf": function() { return /* binding */ signUpContainer; },
/* harmony export */   "Oc": function() { return /* binding */ subtitle; },
/* harmony export */   "PV": function() { return /* binding */ loginBtn; },
/* harmony export */   "TN": function() { return /* binding */ title; }
/* harmony export */ });
/* unused harmony export errorTextStyle */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93802);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("bold"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .tabletSmUp */ .Uv, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.5)),
                                tl: /* [] */ 0
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var subtitle = "sm:text-xl text-mid-gray text-center lg:text-left pb-8";
var loginBtn = "w-24 h-12";
var signUpContainer = "w-full max-w-md mt-24 mx-auto px-4";
var errorTextStyle = "block text-xs text-left mb-2 text-prezzee-red";
 /* title Not a pure module */ 


/***/ })

}]);